import { QueryClientProvider } from '@tanstack/react-query';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { PrimeReactProvider } from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';
import { type PropsWithChildren, useState } from 'react';

import { createQueryClient } from '@/lib/query/queryClient';
import { AuthProvider } from '@/features/auth/context';
import { CustomerProfileApiProvider } from '@/features/account/context';
import { CatalogProvider } from '@/features/catalog/context';
import { AdminCatalogProvider } from '@/features/admin/catalog/context';
import { CatalogMediaProvider } from '@/features/admin/catalog/media/context';

import { FeedbackProvider } from './FeedbackContext';

export function AppProviders({ children }: PropsWithChildren) {
  const [queryClient] = useState(createQueryClient);

  return (
    <PrimeReactProvider value={{ ripple: true }}>
      <QueryClientProvider client={queryClient}>
        <FeedbackProvider>
          <AuthProvider>
            <CustomerProfileApiProvider>
              <CatalogProvider>
                <AdminCatalogProvider>
                  <CatalogMediaProvider>{children}</CatalogMediaProvider>
                </AdminCatalogProvider>
              </CatalogProvider>
            </CustomerProfileApiProvider>
          </AuthProvider>
        </FeedbackProvider>
        <ConfirmDialog />
        <Tooltip target="[data-tooltip]" />
      </QueryClientProvider>
    </PrimeReactProvider>
  );
}
